import { AttackType, EnemyType, ItemType } from "../../../defines/enums"
import { Position, RenderConfig } from "../../../defines/types"
import { Points } from "../../../defines/values"
import { Enemy } from "../enemy"

export class Trap extends Enemy {
  constructor(position: Position, render: RenderConfig, optic: ItemType) {
    const combat = {
      essence: 0,
      maxEssence: 0,
      essenceDefense: 0,
      minAttack: Points.MAX_ENEMY_DAMAGE,
      maxAttack: Points.MAX_ENEMY_DAMAGE,
      attackType: AttackType.DEVOUR,
      attackMessage: "devoured",
    }

    super(EnemyType.DEVOURER, 0, combat, position, render, "trap", optic)
  }

  isAlive(): boolean {
    return true
  }

  takeHit(_amount: number): number {
    return 0
  }
}
